module.exports = __webpack_public_path__ + "img/business4.ca3c69dd.jpg";